import api from './api';

export interface AppleVerifyPayload {
  transactionId?: string;
  originalTransactionId?: string;
}

export interface GoogleVerifyPayload {
  productId?: string;
  purchaseToken?: string;
  orderId?: string;
}

export interface AppleVerifyResponse {
  plan_slug: string;
  status: string;
  payment_provider: 'apple' | 'google';
  requests_used: number;
  requests_limit: number | null;
  trial_ends_at: string | null;
  current_period_end: string | null;
  apple_product_id?: string | null;
  apple_original_transaction_id?: string | null;
  google_product_id?: string | null;
  google_purchase_token?: string | null;
  google_order_id?: string | null;
  environment?: 'Sandbox' | 'Production' | null;
}

export const APPLE_MANAGE_SUBSCRIPTIONS_URL = 'https://apps.apple.com/account/subscriptions';
export const GOOGLE_MANAGE_SUBSCRIPTIONS_URL = 'https://play.google.com/store/account/subscriptions';

export const appleIapApi = {
  verifyTransaction: async (payload: AppleVerifyPayload): Promise<AppleVerifyResponse> => {
    const response = await api.post<{ data: AppleVerifyResponse }>('/subscriptions/apple/verify', {
      transaction_id: payload.transactionId,
      original_transaction_id: payload.originalTransactionId,
    });
    return response.data.data;
  },
};

export const googlePlayBillingApi = {
  verifyPurchase: async (payload: GoogleVerifyPayload): Promise<AppleVerifyResponse> => {
    const response = await api.post<{ data: AppleVerifyResponse }>('/subscriptions/google/verify', {
      product_id: payload.productId,
      purchase_token: payload.purchaseToken,
      order_id: payload.orderId,
    });
    return response.data.data;
  },
};
